import { render, staticRenderFns } from "./livecollect.vue?vue&type=template&id=545969c0&scoped=true&"
import script from "./livecollect.vue?vue&type=script&lang=js&"
export * from "./livecollect.vue?vue&type=script&lang=js&"
import style0 from "./livecollect.vue?vue&type=style&index=0&id=545969c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545969c0",
  null
  
)

export default component.exports